export default "__VITE_ASSET__5c5caee8__"